// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-345d28f4]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.filter-container[data-v-345d28f4] {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  gap: 8px;\n}\n.tab-badge[data-v-345d28f4] {\n  margin-left: 6px;\n}", ""]);
// Exports
module.exports = exports;
